module.exports = __webpack_public_path__ + "img/cloud-showers-heavy.c26d708f.svg";